import { dayjs } from '@retailer-platform/shared-components'

// h:mm A z -> 1:00 PM PST
export const timestampToHourMinute = (timestamp: string, timezone: string): string =>
  dayjs(timestamp).tz(timezone).format(LOCALIZED_TIME_FORMAT_WITH_TIMEZONE)

// MMM D, YYYY - MMM D, YYYY -> Aug 16, 2018 - Aug 17, 2018
export const formatDateRange = (startDate: string, endDate: string, timezone: string) => {
  if (!startDate || !endDate) {
    return ''
  }

  return `${dayjs(startDate).tz(timezone).format(LOCALIZED_SHORT_DATE_FORMAT)} - ${dayjs(endDate)
    .tz(timezone)
    .format(LOCALIZED_SHORT_DATE_FORMAT)}`
}

// Localized formats using dayjs localized formats
// https://day.js.org/docs/en/display/format#list-of-localized-formats
// MM/DD/YYYY h:mm A z -> 08/16/2018 1:00 PM PST
export const LOCALIZED_NUMERICAL_DATE_TIME_FORMAT_WITH_TIMEZONE = 'L LT z'
// MMM D, YYYY h:mm A -> Aug 16, 2018 1:00 PM
export const LOCALIZED_SHORT_DATE_TIME_FORMAT = 'lll'
// MM/DD/YYYY -> 08/16/2018
export const LOCALIZED_NUMERICAL_DATE_FORMAT = 'L'
// MMM D, YYYY -> Aug 16, 2018
export const LOCALIZED_SHORT_DATE_FORMAT = 'll'
// h:mm A z -> 1:00 PM PST
export const LOCALIZED_TIME_FORMAT_WITH_TIMEZONE = 'LT z'
// h:mm A -> 1:00 PM
export const LOCALIZED_TIME_FORMAT = 'LT'

// Non-localized formats (months etc will still be translated)
// z -> PST
export const TIMEZONE_ONLY_FORMAT = 'z'
// MMM -> Aug
export const SHORT_MONTH_ONLY_FORMAT = 'MMM'
// D -> 16
export const NUMERICAL_DAY_ONLY_FORMAT = 'D'
